import { render } from "./Iconbar.vue?vue&type=template&id=37c8e512&ts=true"
import script from "./Iconbar.vue?vue&type=script&lang=ts"
export * from "./Iconbar.vue?vue&type=script&lang=ts"

import "./Iconbar.vue?vue&type=style&index=0&id=37c8e512&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__